import React, { useRef, useState } from "react";
import { Table, Button, Popconfirm } from "antd";
import moment from "moment";

// CSV Generator
import { ExportCSV } from "../Common/ExportCSV";
import { getColumnSearchProps as columnSearchFn } from "../../utils/table";

const ConnectionTableElement = (props) => {
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);
  const { handleDelete, scroll, locale, dataSource, isDeleteConnections } =
    props;

  const getColumnSearchProps = columnSearchFn({
    searchInput,
    searchText,
    searchedColumn,
    setSearchText,
    setSearchedColumn,
  });

  // Table column list
  const columns = [
    {
      title: "Connection ID",
      dataIndex: "_id",
      key: "_id",
      fixed: "left",
      width: "200px",
      ...getColumnSearchProps("_id"),

      sorter: (a, b) => (a._id ? a._id.localeCompare(b._id) : null),
    },
    {
      title: "Connection Name",
      dataIndex: "connectionName",
      key: "connectionName",
      fixed: "left",
      width: "200px",
      ...getColumnSearchProps("connectionName"),

      sorter: (a, b) =>
        a.connectionName
          ? a.connectionName.localeCompare(b.connectionName)
          : null,
    },
    {
      title: "Connection Type",
      dataIndex: "connectionType",
      key: "connectionType",
      width: "250px",
      ...getColumnSearchProps("connectionType"),

      sorter: (a, b) =>
        a.connectionType
          ? a.connectionType.localeCompare(b.connectionType)
          : null,
    },
    {
      title: "Host",
      dataIndex: "host",
      key: "host",
      width: "220px",
      ...getColumnSearchProps("host"),
      sorter: (a, b) => (a.host ? a.host.localeCompare(b.host) : null),
    },
    {
      title: "Port",
      dataIndex: "port",
      key: "port",
      width: "220px",
      ...getColumnSearchProps("port"),
      sorter: (a, b) => a.port - b.port,
    },
    {
      title: "Retry Times",
      dataIndex: "retryTimes",
      key: "retryTimes",
      width: "250px",
      ...getColumnSearchProps("retryTimes"),
    },
    {
      title: "Connect Timeout(ms)",
      dataIndex: "connectTimeout",
      key: "connectTimeout",
      width: "300px",
      ...getColumnSearchProps("connectTimeout"),
    },
    {
      title: "Disconnect Timeout(ms)",
      dataIndex: "disconnectTimeout",
      key: "disconnectTimeout",
      width: "250px",
      ...getColumnSearchProps("disconnectTimeout"),
    },
    {
      title: "Download Zero Bytes",
      dataIndex: "downloadZeroBytes",
      key: "downloadZeroBytes",
      width: "250px",
      ...getColumnSearchProps("downloadZeroBytes"),
      render: (idx, record) => (
        <span>{record.downloadZeroBytes ? "true" : "false"}</span>
      ),

      sorter: (a, b) =>
        (a.downloadZeroBytes ? "true" : "false").localeCompare(
          b.downloadZeroBytes ? "true" : "false",
        ),
    },
    {
      title: "Passive",
      dataIndex: "isPassive",
      key: "isPassive",
      width: "250px",
      ...getColumnSearchProps("isPassive"),
      render: (idx, record) => (
        <span>{record.isPassive ? "true" : "false"}</span>
      ),

      sorter: (a, b) =>
        (a.isPassive ? "true" : "false").localeCompare(
          b.isPassive ? "true" : "false",
        ),
    },
    {
      title: "Force IPv4",
      dataIndex: "forceIPv4",
      key: "forceIPv4",
      width: "250px",
      ...getColumnSearchProps("forceIPv4"),

      render: (idx, record) => (
        <span>{record.forceIPv4 ? "true" : "false"}</span>
      ),
    },
    {
      title: "Auth Type",
      dataIndex: "authType",
      key: "authType",
      width: "250px",
      ...getColumnSearchProps("authType"),

      sorter: (a, b) =>
        a.authType ? a.authType.localeCompare(b.authType) : null,
    },
    {
      title: "User Name",
      dataIndex: "username",
      key: "username",
      width: "250px",
      ...getColumnSearchProps("username"),

      sorter: (a, b) =>
        a.username ? a.username.localeCompare(b.username) : null,
    },

    {
      title: "Created by",
      dataIndex: "create_by",
      key: "create_by",
      width: "200px",
      ...getColumnSearchProps("create_by"),
    },
    {
      title: "Created at",
      dataIndex: "create_at",
      key: "create_at",
      width: "200px",
      render: (_, record) => (
        <span>
          {record.create_at
            ? moment(record.create_at).local().format("YYYY-MM-DD HH:mm:ss")
            : ""}
        </span>
      ),
    },
    {
      title: "Updated by",
      dataIndex: "update_by",
      key: "update_by",
      width: "200px",
      ...getColumnSearchProps("update_by"),
    },
    {
      title: "Updated at",
      dataIndex: "update_at",
      key: "update_at",
      width: "200px",
      render: (_, record) => (
        <span>
          {record.update_at
            ? moment(record.update_at).local().format("YYYY-MM-DD HH:mm:ss")
            : ""}
        </span>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      width: "200px",
      render: (_, record) => (
        <Popconfirm
          title="Sure to delete?"
          onConfirm={() => handleDelete(record._id)}
        >
          <Button
            disabled={isDeleteConnections}
            type="default"
            danger
            size="small"
            style={{ paddingLeft: "5px", paddingRight: "5px" }}
          >
            Delete
          </Button>
        </Popconfirm>
      ),
    },
  ];

  return (
    <div className="is_table_3">
      <ExportCSV
        csvData={dataSource}
        fileName="SFTP Connection List"
        columnNames={columns}
      />
      <Table
        className="sm-custom-table-row-fixed"
        dataSource={dataSource}
        columns={columns}
        scroll={scroll}
        handleDelete={handleDelete}
        locale={locale}
        pagination={{
          defaultPageSize: 10,
          showSizeChanger: true,
          pageSizeOptions: ["10", "25", "50", "100"],
        }}
      />
    </div>
  );
};

export default ConnectionTableElement;
